var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVdCastle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#CD2226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2428 17.2603C15.2837 17.214 15.3036 17.1533 15.2962 17.0914L14.2218 7.11328H7.11956L6.044 17.0914C6.03661 17.1533 6.0565 17.2135 6.09741 17.2603C6.13832 17.3084 6.19457 17.3332 6.25707 17.3332H9.16165V14.6168C9.16165 14.3738 9.27586 14.1411 9.46904 13.997L10.2173 13.4299C10.4884 13.225 10.852 13.225 11.1213 13.4299L11.873 13.997C12.0662 14.1428 12.1804 14.3749 12.1804 14.6168V17.3332H15.0832C15.1457 17.3332 15.2019 17.3084 15.2428 17.2603ZM9.24516 9.79159C9.24516 9.86162 9.18891 9.91891 9.12016 9.91891H8.15369C8.08494 9.91891 8.02869 9.86162 8.02869 9.79159V8.96521C8.02869 8.64635 8.28437 8.38767 8.59744 8.38767H8.67756C8.99177 8.38767 9.24631 8.64635 9.24631 8.96521L9.24516 9.79159ZM13.4735 11.9415C13.4735 12.0127 13.4173 12.0688 13.3485 12.0688H12.3821C12.3133 12.0688 12.2571 12.0127 12.2571 11.9415V11.1163C12.2571 10.7963 12.5127 10.537 12.8258 10.537H12.9059C13.2201 10.537 13.4747 10.7957 13.4747 11.1163L13.4735 11.9415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3398 4.11632C15.3398 4.05266 15.2898 4 15.2273 4H14.4375C14.375 4 14.3233 4.05266 14.3233 4.11632V5.1765C14.3233 5.2633 14.2563 5.33159 14.171 5.33159H12.7608C12.6756 5.33159 12.6085 5.26331 12.6085 5.1765L12.6091 4.11632C12.6091 4.05266 12.5574 4 12.4949 4H11.6415C11.579 4 11.529 4.05266 11.529 4.11632V5.1765C11.529 5.2633 11.4602 5.33159 11.3767 5.33159H9.96479C9.87956 5.33159 9.81251 5.26331 9.81251 5.1765V4.11632C9.81251 4.05266 9.76081 4 9.69831 4H8.84489C8.78239 4 8.73239 4.05266 8.73239 4.11632V5.1765C8.73239 5.2633 8.66364 5.33159 8.58012 5.33159H7.16819C7.08296 5.33159 7.01591 5.26331 7.01591 5.1765V4.11632C7.01591 4.05266 6.96421 4 6.90228 4H6.11421C6.0517 4 6 4.05266 6 4.11632V6.35706C6 6.52777 6.13693 6.66551 6.30455 6.66551H15.0363C15.2039 6.66551 15.3409 6.52777 15.3409 6.35706L15.3403 4.11632H15.3398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdCastle);
export default __webpack_public_path__ + "static/media/VDCastle.526c0748436f9fbbdac8c8ff63b52da6.svg";
export { ForwardRef as ReactComponent };